/**
 * @file Handling manipulation and reading parameters from url
 *
 * - updateURLParams() - Update url from filterObject
 *          filterObj = [{
 *               key: 'Category',
 *               filters: ['', '', '']
 *           },
 *           {
 *               key: 'Category',
 *               filters: ['', '', '']
 *           }];
 *
 *
 * - getUrlParams() - Return filters from url based on a array of filter keys that exist
 *
 * @author Torbjørn Høvde :)
 * @version 1.0
 *
 * @example
 *
 */

import stringHelper from '@/Scripts/lib/helper/stringHelper.js';

const FILTER_SEPERATOR = '|';

function getUrl () {
  return window.location.href;
}

export default {
  methods: {
    /**
        * return url from filterObject
        * @public
        * @param {obj} filterObj Object with filters to set: key paired with a array of filters
        * @returns {void}
        */
    makeUrlFilterParams (filterObj, url) {
      if (!url) {
        url = getUrl();
      }

      for (let i = 0; i < filterObj.length; i++) {
        const filters = filterObj[i].filters;
        const key = filterObj[i].key;

        if (filters.length > 0) {
          // if key has filters, update them
          url = stringHelper.updateUrlParameter(url, key, filters.join(FILTER_SEPERATOR));
        } else {
          // if key has no filters, remove key from url
          url = stringHelper.removeUrlParameter(url, key);
        }
      }
      return url;
    },
    /**
        * Update url from filterObject
        * @public
        * @param {obj} filterObj Object with filters to set: key paired with a array of filters
        * @returns {void}
        */
    updateUrlFilterParams (filterObj) {
      const url = this.makeUrlFilterParams(filterObj);
      if (typeof window.history.pushState === 'function') {
        history.pushState({}, '', url);
      }
    },

    /**
        * Get filters from url
        * @public
        * @param {array} keyArray Array with all categories to search for
        * @returns {obj} Object with filters found in url: 'key' paired with a array of 'filters'
        */
    getUrlFilterParams (keyArray) {
      const foundFilters = [];
      for (let i = 0; i < keyArray.length; i++) {
        const key = keyArray[i];
        const filters = stringHelper.getURLParameter(key);
        if (typeof filters !== 'undefined') {
          foundFilters.push({
            key,
            filters: decodeURIComponent(filters).split(FILTER_SEPERATOR)
          });
        }
      }
      return foundFilters;
    }

  }
};
